export default __webpack_public_path__ + "static/media/photo12.9b896e30.jpg";